@if (!userProcess.hasFullHandling && !userProcess.hasAssistantService) {
  <div
    class="service-item basic-support"
    [class]="{
      large: mode === PurchaseTags.LARGE,
      small: mode === PurchaseTags.SMALL,
      icon_only: mode === PurchaseTags.ICON_ONLY,
    }"
    [matTooltipDisabled]="mode !== PurchaseTags.ICON_ONLY"
    [matTooltip]="'COMMON.LAYOUT.HAS_BASIC_SUPPORT' | translate"
    matTooltipClass="universalTooltip">
    <mat-icon fontSet="material-symbols-outlined">draft</mat-icon>
    @if (mode !== PurchaseTags.ICON_ONLY) {
      {{ 'COMMON.LAYOUT.HAS_BASIC_SUPPORT' | translate }}
    }
  </div>
}
@if (userProcess.hasFullHandling) {
  <div
    class="service-item full-handling"
    [class]="{
      large: mode === PurchaseTags.LARGE,
      small: mode === PurchaseTags.SMALL,
      icon_only: mode === PurchaseTags.ICON_ONLY,
    }"
    [matTooltipDisabled]="mode !== PurchaseTags.ICON_ONLY"
    [matTooltip]="'COMMON.LAYOUT.HAS_FULL_HANDLING' | translate"
    matTooltipClass="universalTooltip">
    <mat-icon fontSet="material-icons-outlined">star</mat-icon>
    @if (mode !== PurchaseTags.ICON_ONLY) {
      {{ 'COMMON.LAYOUT.HAS_FULL_HANDLING' | translate }}
    }
  </div>
}
@if (!userProcess.hasFullHandling && userProcess.hasAssistantService) {
  <div
    class="service-item assistant"
    [class]="{
      large: mode === PurchaseTags.LARGE,
      small: mode === PurchaseTags.SMALL,
      icon_only: mode === PurchaseTags.ICON_ONLY,
    }"
    [matTooltipDisabled]="mode !== PurchaseTags.ICON_ONLY"
    [matTooltip]="'COMMON.LAYOUT.HAS_ASSISTANT_SERVICE' | translate"
    matTooltipClass="universalTooltip">
    <mat-icon fontSet="material-icons-outlined">person</mat-icon>
    @if (mode !== PurchaseTags.ICON_ONLY) {
      {{ 'COMMON.LAYOUT.HAS_ASSISTANT_SERVICE' | translate }}
    }
  </div>
}
